import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useAppContext } from "@/contexts/appContext/AppContext";

type SensitiveValuesToggleButtonProps = {
	readonly className?: string;
};

function SensitiveValuesToggleButton({ className = "" }: SensitiveValuesToggleButtonProps) {
	const { showSensitiveValues, toggleSensitiveValues } = useAppContext();

	const label = showSensitiveValues ? "Ocultar valores sensíveis" : "Mostrar valores sensíveis";
	const icon = showSensitiveValues ? "lucide:eye" : "lucide:eye-off";

	return (
		<Tooltip title={label} placement="bottom">
			<IconButton size="small" className={className} aria-label={label} onClick={toggleSensitiveValues}>
				<FuseSvgIcon>{icon}</FuseSvgIcon>
			</IconButton>
		</Tooltip>
	);
}

export default SensitiveValuesToggleButton;
